module.exports = __webpack_public_path__ + "img/arm-02-right.309f4723.png";